module.exports = __webpack_public_path__ + "static/media/coffee1.dfb923df.jpg";